export default {"src":"/_next/static/media/cloud-storage.397698b9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};